var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49 48H44V46H45C47.76 46 50 43.76 50 41C50 40.45 49.55 40 49 40H47C45.83 40 44.76 40.42 43.91 41.1C43.48 38.77 41.45 37 39 37H37C36.45 37 36 37.45 36 38C36 40.76 38.24 43 41 43H42V48H26V46H27C29.76 46 32 43.76 32 41C32 40.45 31.55 40 31 40H29C27.83 40 26.76 40.42 25.91 41.1C25.48 38.77 23.45 37 21 37H19C18.45 37 18 37.45 18 38C18 40.76 20.24 43 23 43H24V48H8V46H9C11.76 46 14 43.76 14 41C14 40.45 13.55 40 13 40H11C9.83 40 8.76 40.42 7.91 41.1C7.48 38.77 5.45 37 3 37H1C0.45 37 0 37.45 0 38C0 40.76 2.24 43 5 43H6V48H1C0.45 48 0 48.45 0 49C0 49.55 0.45 50 1 50H49C49.55 50 50 49.55 50 49C50 48.45 49.55 48 49 48ZM47 42H47.83C47.42 43.16 46.3 44 45 44H44.17C44.58 42.84 45.7 42 47 42ZM41 41C39.7 41 38.58 40.16 38.17 39H39C40.3 39 41.42 39.84 41.83 41H41ZM29 42H29.83C29.42 43.16 28.3 44 27 44H26.17C26.58 42.84 27.7 42 29 42ZM23 41C21.7 41 20.58 40.16 20.17 39H21C22.3 39 23.42 39.84 23.83 41H23ZM11 42H11.83C11.42 43.16 10.3 44 9 44H8.17C8.58 42.84 9.7 42 11 42ZM5 41C3.7 41 2.58 40.16 2.17 39H3C4.3 39 5.42 39.84 5.83 41H5Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34 33H29V28H31C31.55 28 32 27.55 32 27V23C32 22.45 31.55 22 31 22H29V21C29 18.79 27.21 17 25 17C22.79 17 21 18.79 21 21V22H19C18.45 22 18 22.45 18 23V27C18 27.55 18.45 28 19 28H21V33H16C15.45 33 15 33.45 15 34C15 34.55 15.45 35 16 35H34C34.55 35 35 34.55 35 34C35 33.45 34.55 33 34 33ZM23 21C23 19.9 23.9 19 25 19C26.1 19 27 19.9 27 21V22H23V21ZM27 33H23V28H27V33ZM20 26V24H30V26H20Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25 15C25.55 15 26 14.55 26 14V12C26 11.45 25.55 11 25 11C24.45 11 24 11.45 24 12V14C24 14.55 24.45 15 25 15Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25 9C25.55 9 26 8.55 26 8V6C26 5.45 25.55 5 25 5C24.45 5 24 5.45 24 6V8C24 8.55 24.45 9 25 9Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25 4C25.55 4 26 3.55 26 3V1C26 0.45 25.55 0 25 0C24.45 0 24 0.45 24 1V3C24 3.55 24.45 4 25 4Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.0706 17.9301C32.3306 17.9301 32.5806 17.8301 32.7806 17.6401L34.1906 16.2301C34.5806 15.8401 34.5806 15.2101 34.1906 14.8201C33.8006 14.4301 33.1706 14.4301 32.7806 14.8201L31.3706 16.2301C30.9806 16.6201 30.9806 17.2501 31.3706 17.6401C31.5606 17.8301 31.8206 17.9301 32.0806 17.9301H32.0706Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.3109 13.6901C36.5709 13.6901 36.8209 13.5901 37.0209 13.4001L38.4309 11.9901C38.8209 11.6001 38.8209 10.9701 38.4309 10.5801C38.0409 10.1901 37.4109 10.1901 37.0209 10.5801L35.6109 11.9901C35.2209 12.3801 35.2209 13.0101 35.6109 13.4001C35.8009 13.5901 36.0609 13.6901 36.3209 13.6901H36.3109Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M39.8499 10.1501C40.1099 10.1501 40.3599 10.0501 40.5599 9.86006L41.9699 8.45006C42.3599 8.06006 42.3599 7.43006 41.9699 7.04006C41.5799 6.65006 40.9499 6.65006 40.5599 7.04006L39.1499 8.45006C38.7599 8.84006 38.7599 9.47006 39.1499 9.86006C39.3399 10.0501 39.5999 10.1501 39.8599 10.1501H39.8499Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34 24C34 24.55 34.45 25 35 25H37C37.55 25 38 24.55 38 24C38 23.45 37.55 23 37 23H35C34.45 23 34 23.45 34 24Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M40 24C40 24.55 40.45 25 41 25H43C43.55 25 44 24.55 44 24C44 23.45 43.55 23 43 23H41C40.45 23 40 23.45 40 24Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M46 25H48C48.55 25 49 24.55 49 24C49 23.45 48.55 23 48 23H46C45.45 23 45 23.45 45 24C45 24.55 45.45 25 46 25Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M18.2201 17.6401C18.6101 18.0301 19.2501 18.0301 19.6301 17.6401C20.0201 17.2501 20.0201 16.6201 19.6301 16.2301L18.2201 14.8201C17.8301 14.4301 17.2001 14.4301 16.8101 14.8201C16.4201 15.2101 16.4201 15.8401 16.8101 16.2301L18.2201 17.6401Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M13.9798 13.3901C14.3698 13.7801 14.9998 13.7801 15.3898 13.3901C15.7798 13.0001 15.7798 12.3701 15.3898 11.9801L13.9798 10.5701C13.5898 10.1801 12.9598 10.1801 12.5698 10.5701C12.1798 10.9601 12.1798 11.5901 12.5698 11.9801L13.9798 13.3901Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.4408 9.86006C10.8008 10.2201 11.4608 10.2501 11.8508 9.86006C12.2408 9.47006 12.2408 8.84006 11.8508 8.45006L10.4408 7.04006C10.0508 6.65006 9.42078 6.65006 9.03078 7.04006C8.64078 7.43006 8.64078 8.06006 9.03078 8.45006L10.4408 9.86006Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13 24C13 24.55 13.45 25 14 25H16C16.55 25 17 24.55 17 24C17 23.45 16.55 23 16 23H14C13.45 23 13 23.45 13 24Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M8 25H10C10.55 25 11 24.55 11 24C11 23.45 10.55 23 10 23H8C7.45 23 7 23.45 7 24C7 24.55 7.45 25 8 25Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M3 25H5C5.55 25 6 24.55 6 24C6 23.45 5.55 23 5 23H3C2.45 23 2 23.45 2 24C2 24.55 2.45 25 3 25Z",
    fill: "#0A71FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI8);
export default __webpack_public_path__ + "static/media/i8.47f44fbc3508a9fe40b5975b967f46d5.svg";
export { ForwardRef as ReactComponent };